export default __webpack_public_path__ + "static/media/banco-occidente.3f9873eb.svg";